var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDomPin1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(5.25 2.25)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.485,
    cy: 16.881,
    fill: "#FFDB56",
    rx: 4.189,
    ry: 1.707
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBB24",
    d: "M10.308 16.184c-.654.595-2.12 1.01-3.823 1.01-1.704 0-3.17-.415-3.824-1.01-.234.213-.365.449-.365.697 0 .943 1.876 1.707 4.189 1.707s4.188-.764 4.188-1.707c0-.248-.13-.484-.365-.697z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3BB2E8",
    d: "M6.485.898A6.086 6.086 0 0 0 .399 6.983c0 5.119 6.086 9.828 6.086 9.828s6.086-4.71 6.086-9.828A6.086 6.086 0 0 0 6.485.898zm0 8.513a2.427 2.427 0 1 1 0-4.855 2.427 2.427 0 0 1 0 4.855z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3097CF",
    d: "M6.485.898c-.236 0-.468.014-.697.04a6.086 6.086 0 0 1 5.389 6.045c0 4.04-3.792 7.825-5.389 9.24.426.379.697.588.697.588s6.086-4.71 6.086-9.827A6.086 6.086 0 0 0 6.485.898z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.485.51A6.48 6.48 0 0 0 .012 6.984c0 2.216 1.054 4.6 3.133 7.082.31.369.617.71.912 1.023-1.342.366-2.148 1.025-2.148 1.793 0 1.36 2.358 2.094 4.576 2.094 2.218 0 4.575-.734 4.575-2.094 0-.768-.805-1.426-2.147-1.793a21.076 21.076 0 0 0 1.66-1.974.387.387 0 1 0-.623-.46 20.786 20.786 0 0 1-2 2.311.387.387 0 0 0-.169.168c-.559.549-1.029.956-1.296 1.18-.264-.221-.727-.623-1.279-1.166a.387.387 0 0 0-.194-.192C3.26 13.19.786 10.144.786 6.984a5.705 5.705 0 0 1 5.699-5.7 5.705 5.705 0 0 1 5.699 5.7c0 1.372-.468 2.854-1.39 4.404a.387.387 0 0 0 .665.396c.995-1.672 1.499-3.287 1.499-4.8A6.48 6.48 0 0 0 6.485.51zm0 16.688a.386.386 0 0 0 .237-.08c.047-.038.694-.542 1.556-1.385 1.306.266 2.008.779 2.008 1.148 0 .275-.378.6-.986.848-.745.304-1.745.472-2.815.472-2.32 0-3.802-.782-3.802-1.32 0-.37.702-.882 2.009-1.148a19.695 19.695 0 0 0 1.556 1.384c.07.054.153.081.237.081z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.258 5.94a.387.387 0 0 0-.479.266 2.818 2.818 0 0 0 2.705 3.592A2.818 2.818 0 0 0 9.3 6.984a2.818 2.818 0 0 0-4.498-2.256.387.387 0 0 0 .464.62 2.042 2.042 0 0 1 3.26 1.635c0 1.125-.915 2.04-2.04 2.04A2.042 2.042 0 0 1 4.524 6.42a.387.387 0 0 0-.266-.48z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomPin1);
export default __webpack_public_path__ + "static/media/dom_pin_1.6a6ce6e8dab6d6ecd3e5adc8b08f758e.svg";
export { ForwardRef as ReactComponent };